import { render, staticRenderFns } from "./Identity.vue?vue&type=template&id=32bdbc45&"
import script from "./Identity.vue?vue&type=script&lang=ts&"
export * from "./Identity.vue?vue&type=script&lang=ts&"
import style0 from "./Identity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports